function getRelativeOffsetValue(_ref) {
  var targetOffset = _ref.targetOffset,
    targetType = _ref.targetType,
    isTargetDueDate = _ref.isTargetDueDate,
    targetOffsetUnit = _ref.targetOffsetUnit;
  var relativeTarget = {
    due: {
      creation: {
        day: 'nudge_remind_panel_count_days_after_account_creation_due',
        week: 'nudge_remind_panel_count_weeks_after_account_creation_due',
        month: 'nudge_remind_panel_count_months_after_account_creation_due',
        year: 'nudge_remind_panel_count_years_after_account_creation_due'
      },
      audience: {
        day: 'nudge_remind_panel_count_days_after_joining_audience_due',
        week: 'nudge_remind_panel_count_weeks_after_joining_audience_due',
        month: 'nudge_remind_panel_count_months_after_joining_audience_due',
        year: 'nudge_remind_panel_count_years_after_joining_audience_due'
      }
    },
    target: {
      creation: {
        day: 'nudge_remind_panel_count_days_after_account_creation_target',
        week: 'nudge_remind_panel_count_weeks_after_account_creation_target',
        month: 'nudge_remind_panel_count_months_after_account_creation_target',
        year: 'nudge_remind_panel_count_years_after_account_creation_target'
      },
      audience: {
        day: 'nudge_remind_panel_count_days_after_joining_audience_target',
        week: 'nudge_remind_panel_count_weeks_after_joining_audience_target',
        month: 'nudge_remind_panel_count_months_after_joining_audience_target',
        year: 'nudge_remind_panel_count_years_after_joining_audience_target'
      }
    }
  };
  if (targetOffset && targetType) {
    var offsetTimeValue = targetOffsetUnit || 'day';
    var targetOffsetKey = isTargetDueDate ? 'due' : 'target';
    var relativeTargetOffset = relativeTarget[targetOffsetKey][targetType][offsetTimeValue];
    return {
      relativeTargetOffset: relativeTargetOffset,
      count: targetOffset
    };
  }
  return undefined;
}
export default getRelativeOffsetValue;